import { connect } from 'react-redux'
import { setConfigurator } from '../../../actions'

import TypeColorItem from './TypeColorItem'

const mapStateToProps = state => ({
  configurator: state.configurator
})

const mapDispatchToProps = {
  setConfigurator
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypeColorItem)
